const baseUrl = import.meta.env.VITE_DOMAIN;

const cognitoConfig = {
	cognitoClient: import.meta.env.VITE_COGNITO_CLIENT ?? '',
	cognitoUrl: import.meta.env.VITE_COGNITO_BASE_URL,
	redirectUrl: `${baseUrl}/codex/`,
};

export default cognitoConfig;
